import { GetSeoMetaResponse, MetiClient } from '@sbt-web/networking';

interface SeoRequest {
  category?: string;
  categoryLabel?: string;
  adType?: string;
  adTypeLabel?: string;
  region?: string;
  regionLabel?: string;
  province?: string;
  provinceLabel?: string;
  city?: string;
  cityLabel?: string;
  searchQuery?: string;
  pagination?: string;
  filters?: {
    carBrand?: string;
    carModel?: string;
    carType?: string;
    carFuel?: string;
    motorbikeBrand?: string;
    motorbikeModel?: string;
    motorbikeType?: string;
    [x: string]: string | undefined;
  };
}

class SeoClient {
  readonly baseUrl: string;
  readonly channel: string;
  readonly timeout: number;
  private metiClient: MetiClient;
  private _response: GetSeoMetaResponse | null;
  private ucFirstFields = ['categoryLabel'];

  constructor(baseUrl: string, channel: string, timeout = 100) {
    this.baseUrl = baseUrl;
    this.channel = channel;
    this.timeout = timeout;
    this.metiClient = new MetiClient(this.baseUrl, this.channel, this.timeout);
    this._response = null;
  }

  async getSeoData(obj: SeoRequest): Promise<GetSeoMetaResponse> {
    const response: GetSeoMetaResponse =
      await this.metiClient.getSeoConfiguration(this.encodeSeoRequest(obj));
    if (response && response.status == 200) {
      this._response = response;
    }
    return response;
  }

  get response(): GetSeoMetaResponse | null {
    return this._response;
  }

  encodeSeoRequest(obj: SeoRequest): string {
    const query: string[] = [];

    Object.keys(obj).forEach((key) => {
      const accessKey = key as keyof SeoRequest;

      const value = obj[accessKey];

      if (value != undefined) {
        if (typeof value === 'object') {
          query.push(`${key}=${encodeURIComponent(JSON.stringify(value))}`);
        } else {
          if (this.ucFirstFields.includes(key)) {
            query.push(`${key}=${encodeURIComponent(this.ucfirst(value))}`);
          } else {
            query.push(`${key}=${encodeURIComponent(value)}`);
          }
        }
      }
    });

    return query.join('&');
  }

  ucfirst(s: string): string {
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
}

export default SeoClient;
export type { SeoRequest };
